export { jobPositionsSk } from './sk';
export { jobPositionsEn } from './en';
export { jobPositionsCz } from './cz';

// Helper function to get job positions by language
import { jobPositionsSk } from './sk';
import { jobPositionsEn } from './en';
import { jobPositionsCz } from './cz';

export function getJobPositions(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobPositionsSk;
    case 'en':
      return jobPositionsEn;
    case 'cz':
      return jobPositionsCz;
    default:
      return jobPositionsSk; // fallback to Slovak
  }
}